export default __webpack_public_path__ + "static/media/WNo.2-0.bc8d033a.jpg";